import { IPreCasInterview } from '../../../../../types';

type Fields = Pick<
  IPreCasInterview,
  | 'workWhileStudy'
  | 'maxWorkHoursPerWeek'
  | 'whyWorkWhileStudy'
  | 'whyWorkWhileStudyOther'
  | 'affordCourseAndLivingWithoutWorking'
  | 'affordCourseAndLivingWithoutWorkingNo'
  | 'completeDegreeWorkCountry'
  | 'expectedSalary'
  | 'furtherStudyInUk'
  | 'furtherStudyCareerPlans'
>;

export function getPageStatus(fields: Fields): { complete: boolean } {
  const {
    workWhileStudy,
    maxWorkHoursPerWeek,
    whyWorkWhileStudy,
    whyWorkWhileStudyOther,
    affordCourseAndLivingWithoutWorking,
    affordCourseAndLivingWithoutWorkingNo,
    completeDegreeWorkCountry,
    expectedSalary,
    furtherStudyInUk,
    furtherStudyCareerPlans,
  } = fields;

  const complete =
    workWhileStudy !== undefined &&
    (workWhileStudy === true ? maxWorkHoursPerWeek !== '' : true) &&
    (workWhileStudy === true ? whyWorkWhileStudy !== '' : true) &&
    (whyWorkWhileStudy === 'Other' ? whyWorkWhileStudyOther !== '' : true) &&
    (workWhileStudy === true ? affordCourseAndLivingWithoutWorking !== undefined : true) &&
    (affordCourseAndLivingWithoutWorking === false ? affordCourseAndLivingWithoutWorkingNo !== '' : true) &&
    completeDegreeWorkCountry !== '' &&
    Number(expectedSalary) > 0 &&
    furtherStudyInUk !== undefined &&
    (furtherStudyInUk === true ? furtherStudyCareerPlans !== '' : true);

  return { complete };
}
